export const getEventNameProps = (sel) => {
    return {
        sportName: sel.sportName,
        leagueName: sel.eventDisplayName
    };
};
//# sourceMappingURL=getEventNameProps.js.map